import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, PropType } from 'vue'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import { MinimumTimeslot } from '@/models/public/service.model'
import {
  formatDurationHoursAndMinutes,
  formatIntlDateOnly,
  formatIntlTime,
} from '@/utils/formatters'
import BaseTag from '@/components/BaseTag.vue'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/endOfDay'
import { isEqual } from 'date-fns'
import { cloneDeep } from 'lodash'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'DurationTag',
  props: {
  selectedSlots: {
    type: Array as PropType<MinimumTimeslot[]>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props



const i18n = useI18n()

const earliestTime = computed(() => {
  let earliestTime: Date | undefined
  props.selectedSlots.forEach((slot: MinimumTimeslot) => {
    const slotStart = new Date(slot.start)
    if (!earliestTime || isBefore(slotStart, earliestTime)) {
      earliestTime = slotStart
    }
  })
  return earliestTime
})

const latestTime = computed(() => {
  let latestTime: Date | undefined
  props.selectedSlots.forEach((slot: MinimumTimeslot) => {
    const slotEnd = new Date(slot.end)
    if (!latestTime || isAfter(slotEnd, latestTime)) {
      latestTime = slotEnd
    }
  })
  return latestTime
})

const slotsDurationString = computed(() => {
  if (!earliestTime.value || !latestTime.value) return ''

  const start = nullifySeconds(earliestTime.value)
  const end = nullifySeconds(latestTime.value)
  const dayStart = nullifySeconds(startOfDay(earliestTime.value))
  const dayEnd = nullifySeconds(endOfDay(latestTime.value))

  if (isEqual(start, dayStart) && isEqual(end, dayEnd)) {
    return i18n.t('bookingWidget.wholeDay', { date: formatIntlDateOnly(start) })
  }
  return `${formatIntlTime(start)} - ${formatIntlTime(
    end,
  )} (${formatDurationHoursAndMinutes(start, end)})`
})

const nullifySeconds = (date: Date) => {
  const mutableDate = cloneDeep(date)
  mutableDate.setSeconds(0)
  mutableDate.setMilliseconds(0)
  return mutableDate
}

return (_ctx: any,_cache: any) => {
  return (_unref(slotsDurationString).length)
    ? (_openBlock(), _createBlock(BaseTag, {
        key: 0,
        label: _unref(slotsDurationString),
        "hide-close": "",
        class: "experience-event-availability-duration-tag"
      }, null, 8, ["label"]))
    : _createCommentVNode("", true)
}
}

})